import { activeScopeKey } from '@features/account-view/active';

/* One provider's queries live under its id, so a save can refresh them all at once. */
export const providerKeys = {
  all: ['storage-providers'] as const,
  /* EN-4396: the account and division levels (and division filters) are cached apart. */
  list: (params: unknown, summary: boolean) =>
    [
      ...providerKeys.all,
      'list',
      { params, summary, scope: activeScopeKey() },
    ] as const,
  types: () => [...providerKeys.all, 'types'] as const,
  /* Lookups other screens make; scoped like the list, as the API answers per level. */
  hierarchy: (regionId: string, grouped: boolean) =>
    [
      ...providerKeys.all,
      'hierarchy',
      { regionId, grouped, scope: activeScopeKey() },
    ] as const,
  returnCenters: (regionId: string) =>
    [
      ...providerKeys.all,
      'return-centers',
      { regionId, scope: activeScopeKey() },
    ] as const,
  scmOptions: () =>
    [...providerKeys.all, 'scm-options', { scope: activeScopeKey() }] as const,
  defaultPredictions: (regionId: string) =>
    [
      ...providerKeys.all,
      'default-predictions',
      { regionId, scope: activeScopeKey() },
    ] as const,
  threshold: (regionId: string) =>
    [
      ...providerKeys.all,
      'threshold',
      { regionId, scope: activeScopeKey() },
    ] as const,
  wmsWarehouses: () => [...providerKeys.all, 'wms-warehouses'] as const,
  provider: (id: string) => [...providerKeys.all, id] as const,
  detail: (id: string) => [...providerKeys.provider(id), 'detail'] as const,
  cbm: (id: string) => [...providerKeys.provider(id), 'cbm'] as const,
  inventory: (id: string, params: unknown) =>
    [...providerKeys.provider(id), 'inventory', params] as const,
  inventoryV2: (id: string, page: number, pageSize: number) =>
    [...providerKeys.provider(id), 'inventory-v2', { page, pageSize }] as const,
  unmatched: (id: string, params: unknown) =>
    [...providerKeys.provider(id), 'unmatched', params] as const,
  rates: (id: string) => [...providerKeys.provider(id), 'rates'] as const,
  materials: (id: string) =>
    [...providerKeys.provider(id), 'materials'] as const,
  invoices: (id: string, params: unknown) =>
    [...providerKeys.provider(id), 'invoices', params] as const,
  invoice: (id: string, invoiceId: string) =>
    [...providerKeys.provider(id), 'invoice', invoiceId] as const,
  invoiceLogs: (id: string, invoiceId: string, params: unknown) =>
    [...providerKeys.invoice(id, invoiceId), 'logs', params] as const,
  carriers: (id: string) => [...providerKeys.provider(id), 'carriers'] as const,
};
